<template>
  <div>
    <h1 class="title">Gestione prodotto</h1>

    <section class="content">
      <form v-on:submit="formSubmit">
        <fieldset :disabled="$ajax.anyLoading">
          <div class="columns">
            <div class="column">
              <b-field label="Nome prodotto">
                <b-input
                  v-model.trim="editProduct.name"
                  v_uppercase="editProduct.name"
                  placeholder="Nome prodotto"
                  required
                ></b-input>
              </b-field>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">Categoria</label>
                <div class="control">
                  <input
                    class="input"
                    type="text"
                    placeholder="Categoria"
                    v-model.trim="editProduct.category"
                  />
                </div>Raggruppamento automatico
              </div>
            </div>
            <div class="column">
              <ServiceTipologyDD v-model="editProduct.tipologyId" expanded nullable></ServiceTipologyDD>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <b-field label="Unità">
                <b-input
                  v-model.number="editProduct.pieces"
                  placeholder="Unità"
                  type="number"
                  min="1"
                  required
                ></b-input>
              </b-field>Se si tratta di una
              <b>confezione</b> specificare il numero di prodotti contenuti
            </div>
            <div class="column">
              <b-field label="Quantità">
                <b-input v-model="editProduct.quantity" placeholder="Quantità" required></b-input>
              </b-field>Specificare la quantità contenuta nel singolo prodotto
            </div>
            <div class="column">
              <!-- UNITà DI MISURA  -->
              <b-field label="Unità di misura">
                <b-select
                  placeholder="Seleziona unità di misura"
                  v-model="editProduct.umId"
                  expanded
                  required
                >
                  <option
                    v-for="option in $ajax.getObject('productsUm')"
                    :value="option.id"
                    :key="option.id"
                  >{{ option.name }}</option>
                </b-select>
              </b-field>
            </div>

            <div class="column">
              <b-field label="Codice EAN">
                <b-input v-model.trim="editProduct.ean" placeholder="Codice EAN"></b-input>
              </b-field>
            </div>

            <div class="column">
              <b-field label="Gadget">
                <div class="field">
                  <b-switch v-model="editProduct.isGadget"></b-switch>
                </div>
              </b-field>
            </div>
          </div>

          <section class="content">
            <div class="buttons is-right">
              <button type="submit" class="button is-success" :disabled="$ajax.anyLoading">
                <span class="icon is-small">
                  <i class="fas fa-check"></i>
                </span>
                <span>Salva prodotto</span>
              </button>
            </div>
          </section>
        </fieldset>
      </form>
    </section>
  </div>
</template>


<script>
import ServiceTipologyDD from "../components/dropdown/ServiceTipologyDD";

export default {
  name: "products",
  components: { ServiceTipologyDD },
  data() {
    return {
      editProduct: {
        id: 0,
        pieces: 1,
        category: "",
        tipologyId: null
      }
    };
  },
  methods: {
    formSubmit(e) {
      e.preventDefault();

      const vm = this;
      if (this.editProduct.id) {
        // update
        this.$ajax.request({
          address: "/products/" + this.editProduct.id,
          method: "PUT",
          data: this.editProduct,
          onSuccess: response => {
            vm.editProduct = response.data;
          }
        });
      } else {
        // new
        this.$ajax.request({
          address: "/products/",
          method: "POST",
          data: this.editProduct,
          onSuccess: response => {
            vm.editProduct = response.data;
          }
        });
      }
    }
  },
  mounted() {
    if (this.$route.params.user_id) {
      this.editProduct.clientId = this.$route.params.user_id;
    }

    if (this.$route.params.product_id) {
      this.editProduct.id = this.$route.params.product_id;

      const vm = this;
      this.$ajax.request({
        address: "/products/" + this.editProduct.id,
        method: "GET",
        onSuccess: response => {
          vm.editProduct = response.data;
        }
      });
    }
  }
};
</script>
